import React, { Component } from 'react';
import Input from './input';

export default class InputSearch extends Component{
    constructor(props){
        super(props)
    }

    handleOnSearch(e){
        let value = e && e.target ? e.target.value : e;
        value = value === '' ? null : value;
        if (this.props.model) {
            this.props.model.setValue(value, true);
            this.props.model.execute('search', value);
          }
    }

    render(){
        return <Input {...this.props} onSearch={e => this.handleOnSearch(e)}/>
    }
}


// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/inputsearch.jsx